// SPDX-License-Identifier: AGPL-3.0-or-later

import {MessageFlags} from '@fluxer/constants/src/ChannelConstants';

/** Content prefix stripped at send time and converted into {@link MessageFlags.EMOTE}. */
export const EMOTE_CONTENT_PREFIX = '@emote ';

/** True when the message was sent as a `/me` (or `/glmode`) emote. */
export function isMeEmoteMessage(message: {hasFlag: (flag: number) => boolean}): boolean {
	return message.hasFlag(MessageFlags.EMOTE);
}

/** Wraps `/me` action text into the wire prefix + italic body sent to the API. */
export function wrapMeEmoteContent(action: string): string {
	return `${EMOTE_CONTENT_PREFIX}_${action}_`;
}

/**
 * Inner action text for a flagged `/me` emote. Strips a single `_…_` wrap when present;
 * otherwise returns the trimmed body as-is.
 */
export function unwrapMeEmoteContent(content: string): string {
	const trimmed = content.trim();
	if (trimmed.length < 3) {
		return trimmed;
	}
	if (trimmed.startsWith('__') || trimmed.startsWith('**')) {
		return trimmed;
	}
	if (trimmed.startsWith('_') && trimmed.endsWith('_')) {
		const inner = trimmed.slice(1, -1);
		if (inner.length > 0) {
			return inner;
		}
	}
	return trimmed;
}
